/* One first-source value shared by both native Drive waitlist forms. */
(() => {
  'use strict';

  const storageKey = 'taevu_drive_first_source';
  const validSource = (value) => ['A', 'B', 'C'].includes(value);
  let firstSource = null;

  function resolveFirstSource() {
    // Keep the page usable even when storage access or URL parsing is denied.
    try {
      const saved = window.localStorage.getItem(storageKey);
      if (validSource(saved)) firstSource = saved;
    } catch (error) {
      // Fall back to this page's in-memory value, without blocking signup.
    }

    if (!validSource(firstSource)) {
      try {
        const incoming = new URLSearchParams(window.location.search).get('source');
        if (validSource(incoming)) {
          firstSource = incoming;
          try {
            window.localStorage.setItem(storageKey, firstSource);
          } catch (error) {
            // The current page can still attribute the native form submission.
          }
        }
      } catch (error) {
        // No source is preferable to interrupting a native form submission.
      }
    }
    return firstSource;
  }

  function syncForm(form) {
    try {
      const tags = form.querySelector('[data-waitlist-tags]');
      if (!tags) return;
      const source = resolveFirstSource();
      const values = tags.value.split(',').map((tag) => tag.trim()).filter(Boolean);
      const baseTags = values.filter((tag) => !/^TAEVU_SOURCE_[ABC]$/.test(tag));
      if (validSource(source)) baseTags.push('TAEVU_SOURCE_' + source);
      tags.value = baseTags.join(',');
    } catch (error) {
      // Attribution must never prevent the original Shopify form from working.
    }
  }

  function syncForms() {
    document.querySelectorAll('.tv-waitlist-form').forEach(syncForm);
  }

  // Capture on every storefront page, including pages without waitlist forms.
  resolveFirstSource();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncForms);
  } else {
    syncForms();
  }
  window.addEventListener('pageshow', syncForms);
  document.addEventListener('shopify:section:load', syncForms);
  document.addEventListener('submit', (event) => {
    if (event.target && event.target.matches('.tv-waitlist-form')) {
      syncForm(event.target);
    }
  }, true);
})();